import { Link } from "react-router-dom";
import { WHATSAPP_COMMUNITY_URL } from "@/constants/social";

export default function Footer() {
  return (
    <footer className="bg-[#1A2A28] text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1 - Logo */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/71bd3ce9-ea40-4eb5-8ec2-3e5ee5114aee.png"
                alt="ASC Sonatel"
                className="h-12 w-12 object-contain"
              />
              <div>
                <div className="font-bold text-lg">ASC Sonatel</div>
                <div className="text-xs text-[#1A8C7A]">Association Sportive & Culturelle</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              L'association sportive et culturelle de la SONATEL, rassemblant les salariés autour du sport, de la culture et de la communauté depuis 1985.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-whatsapp-line", href: WHATSAPP_COMMUNITY_URL },
                { icon: "ri-linkedin-line", href: "#" },
                { icon: "ri-twitter-x-line", href: "#" },
                { icon: "ri-facebook-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target={s.href.startsWith("http") ? "_blank" : undefined}
                  rel={s.href.startsWith("http") ? "noreferrer" : undefined}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-gray-400 hover:border-[#E8521A] hover:text-[#E8521A] transition-all duration-200 cursor-pointer"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 - Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-500 mb-5">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: "Accueil", path: "/" },
                { label: "Le Club", path: "/club" },
                { label: "Sport", path: "/sport/calendrier" },
                { label: "Communauté", path: "/communaute/squads" },
                { label: "Culture & Familles", path: "/culture" },
                { label: "Boutique", path: "/boutique" },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-400 hover:text-[#E8521A] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Sport */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-500 mb-5">Sport</h4>
            <ul className="space-y-3">
              {[
                { label: "Calendrier", path: "/sport/calendrier" },
                { label: "Résultats", path: "/sport/resultats" },
                { label: "Événements", path: "/sport/evenements" },
                { label: "Défis Sportifs", path: "/" },
                { label: "Classements", path: "/sport/resultats" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-400 hover:text-[#E8521A] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 - Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-500 mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#E8521A]"></i>
                </div>
                <span className="text-sm text-gray-400">Siège SONATEL, est situé au 64, Voie de Dégagement Nord (VDN), Cité Keur Gorgui à Dakar, Sénégal</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#E8521A]"></i>
                </div>
                <span className="text-sm text-gray-400">77 892 82 82</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#E8521A]"></i>
                </div>
                <span className="text-sm text-gray-400">ASCSonatel2@orange-sonatel.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © 2026 ASC Sonatel — Tous droits réservés
          </p>
          <div className="flex items-center gap-6">
            <Link to="/suppression-compte" className="text-sm text-gray-500 hover:text-[#E8521A] transition-colors">
              Suppression compte
            </Link>
            <Link to="/confidentialite" className="text-sm text-gray-500 hover:text-[#E8521A] transition-colors">
              Politique de confidentialité
            </Link>
            <Link to="/conditions-utilisation" className="text-sm text-gray-500 hover:text-[#E8521A] transition-colors">
              Conditions d’utilisation
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
